export default "__VITE_ASSET__BNkTrS_X__"